@if (errorList.length > 0) {
  <div
    class="alert alert-error"
    id="{{id}}_Error_Box"
    role="alert"
    aria-atomic="true">
    <h2 id="{{id}}_Error_Box_Title">{{boxTitle}}</h2>
    @for (error of errorList; track error; let i = $index) {
      <div
        class="row ba-form-row"
        [attr.data-index]="i">
        <div class="col-12 col-md-4 ba-copytext">
          @if (!link) {
            <span id="{{id}}_Error_Box_Label_{{i}}">{{error.label}}</span>
          }
          @if (link) {
            <a [href]="'#' + error.elementId" (click)="jumpTo(error.elementId)">{{error.label}}</a>
          }
        </div>
        <div class="col-xs-12 col-md-8">
          <span id="{{id}}_Error_Box_Text_{{i}}">{{error.message}}</span>
        </div>
      </div>
    }
    <div class="row ba-form-row ba-copytext">
      <div class="col-12">
        <a #firstButton
          class="ba-link ba-link-secondary"
          href="#"
          (click)="$event.preventDefault(); jumpToInvalidField()">
          Zum ersten Fehler springen.
        </a>
      </div>
    </div>
  </div>
}
